import {Injectable, Injector} from '@angular/core';
import {MvsCrudObjectHistoryComponent} from "../components/mvs-crud-object-history/mvs-crud-object-history.component";
import {DtoHistory} from "../../dto/dto.history";
import {MvsMessageService} from "../../service/message/mvs-message.service";
import {BehaviorSubject} from "rxjs";

@Injectable({providedIn: 'root'})
export class MvsCrudObjectHistoryService {

    component: MvsCrudObjectHistoryComponent;

    // TM-1000001467: Panel mode support
    private showHistoryPanelSubject = new BehaviorSubject<boolean>(false);
    showHistoryPanel$ = this.showHistoryPanelSubject.asObservable();

    private historyDataSubject = new BehaviorSubject<{objectType: string, objectId: number} | null>(null);
    historyData$ = this.historyDataSubject.asObservable();

    // TM-1000001467: Refresh trigger for history panel
    private refreshHistorySubject = new BehaviorSubject<boolean>(false);
    refreshHistory$ = this.refreshHistorySubject.asObservable();

    constructor(protected injector: Injector, protected messageService: MvsMessageService) {
    }

    public registerComponent(component: MvsCrudObjectHistoryComponent) {
        this.component = component;
    }

    public unregisterComponent(component: MvsCrudObjectHistoryComponent) {
        if (this.component == component) {
            this.component = null;
        }
    }

    public showHistory(objectType: string, objectId: number, callback: (data: DtoHistory) => void) {

        if (!this.component) {
            this.messageService.showErrorMessage("Fehler :-/", "Component wurde nicht registriert!");
            return;
        }

        this.component.showHistory(objectType, objectId, callback);
    }

    // TM-1000001467: Panel mode methods
    public showHistoryPanel(objectType: string, objectId: number): void {
        this.historyDataSubject.next({objectType, objectId});
        this.showHistoryPanelSubject.next(true);
    }

    public hideHistoryPanel(): void {
        this.showHistoryPanelSubject.next(false);
        this.historyDataSubject.next(null);
    }

    public toggleHistoryPanel(objectType: string, objectId: number): void {
        if (this.showHistoryPanelSubject.value) {
            this.hideHistoryPanel();
        } else {
            this.showHistoryPanel(objectType, objectId);
        }
    }

    public get isHistoryPanelVisible(): boolean {
        return this.showHistoryPanelSubject.value;
    }

    public get currentHistoryData(): {objectType: string, objectId: number} | null {
        return this.historyDataSubject.value;
    }

    // TM-1000001467: Refresh history panel after save
    public refreshHistoryPanel(): void {
        if (this.showHistoryPanelSubject.value) {
            this.refreshHistorySubject.next(true);
        }
    }
}
